import type { SVGProps } from 'react';

export const SvgIconCategory140 = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.375 15.125H27.7625C27.947 15.1254 28.128 15.0741 28.2849 14.9769C28.4418 14.8797 28.5682 14.7404 28.65 14.575L30.95 9.975C31.064 9.74462 31.086 9.47953 31.0117 9.23348C30.9375 8.98743 30.7724 8.77884 30.55 8.65L24.375 5.125"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.37526 15.125H4.98777C4.80322 15.1254 4.62225 15.0741 4.46538 14.9769C4.30851 14.8797 4.18203 14.7404 4.10026 14.575L1.80026 9.975C1.68631 9.74462 1.66424 9.47953 1.73852 9.23348C1.8128 8.98743 1.97787 8.77884 2.20026 8.65L8.37526 5.125"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.375 5.125C20.375 6.18587 19.9536 7.20328 19.2034 7.95343C18.4533 8.70357 17.4359 9.125 16.375 9.125C15.3141 9.125 14.2967 8.70357 13.5466 7.95343C12.7964 7.20328 12.375 6.18587 12.375 5.125H8.375V26.125C8.375 26.3902 8.48036 26.6446 8.66789 26.8321C8.85543 27.0196 9.10978 27.125 9.375 27.125H23.375C23.6402 27.125 23.8946 27.0196 24.0821 26.8321C24.2696 26.6446 24.375 26.3902 24.375 26.125V5.125H20.375Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
